/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NextGenReportGetRequest {
    getFixupPrototypeFunction() { return NextGenReportGetRequest.fixupPrototype; }

    static newInstance(model: Partial<NextGenReportGetRequest>): NextGenReportGetRequest {
        let obj = Object.assign(new NextGenReportGetRequest(), model);
        NextGenReportGetRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NextGenReportGetRequest>): NextGenReportGetRequest {
        if (!model) return null;
        return NextGenReportGetRequest.newInstance(<NextGenReportGetRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NextGenReportGetRequest) {
        if (!obj) return;

        models.NextGenReportGetRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NextGenReportGetRequest): boolean {
        Object.setPrototypeOf(obj, NextGenReportGetRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * If true, generates a new download link for the report if the existing link has expired.
     */
    refresh_download_link: boolean = false;

}
